import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

type StateProps = {
    content:
        | 'contentReview'
        | 'contentOffline'
        | 'contentFail'
        | 'contentLoading'
        | 'topicOffline'
        | 'topicReview'
        | 'logout'
        | 'contentFail';
};

const State = ({ content }: StateProps) => {
    let imageUrl = '';
    let isShow = true;

    switch (content) {
        case 'topicOffline':
            imageUrl =
                'https://x0.ifengimg.com/ucms/2022_38/929056FD26D34D2F7AAD7CB834AC8654E2F32FDB_size234_w1020_h780.png';
            break;
        case 'contentOffline':
            imageUrl =
                'https://x0.ifengimg.com/ucms/2022_38/718D453D8A58CCB282833A14EC05428D6E3ED54A_size233_w1020_h780.png';
            break;
        case 'topicReview':
            imageUrl =
                'https://x0.ifengimg.com/ucms/2022_38/1C37AC19F8FDCB9A59D770FF48DAA84AFD96AA3D_size142_w1020_h780.png';
            break;
        case 'logout':
            imageUrl =
                'https://x0.ifengimg.com/ucms/2022_38/7EA1DABC02245BB8B8911BAE6E74D7F486AA0732_size205_w1020_h780.png';
            break;
        case 'contentReview':
            imageUrl =
                'https://x0.ifengimg.com/ucms/2022_38/320220F058727B4AE58E9AF1A39CAE9BFD257CD5_size147_w1020_h780.png';
            break;
        case 'contentFail':
            imageUrl =
                'https://x0.ifengimg.com/ucms/2022_38/5569F31AB7A766B6233C805417E20E55906B6E77_size340_w1020_h780.png';
            break;
        case 'contentLoading':
            isShow = false;
            break;
        default:
            isShow = false;
            break;
    }

    return isShow ? (
        <div className={styles.state}>
            <img className={styles.statePic} src={formatImageWebpAuto(imageUrl, 300)} />
        </div>
    ) : null;
};

export default errorBoundary(State);
